__turbopack_context__.v({
  "buttonLabel": "Vaxx6q_buttonLabel",
  "buttonsWrapper": "Vaxx6q_buttonsWrapper",
  "dateLabel": "Vaxx6q_dateLabel",
  "modalTimer": "Vaxx6q_modalTimer",
  "timerDetails": "Vaxx6q_timerDetails",
  "timerLabel": "Vaxx6q_timerLabel",
  "timerValue": "Vaxx6q_timerValue",
  "timerWrapper": "Vaxx6q_timerWrapper",
  "timerWrapperWithTimer": "Vaxx6q_timerWrapperWithTimer",
});
